import { animate, query, stagger, state, style, transition, trigger } from "@angular/animations";

export const listAnimation = trigger('listAnimation', [
  transition('* <=> *', [
    query(':enter',
      [style({ opacity: 0 }), stagger('60ms', animate('600ms ease-out', style({ opacity: 1 })))],
      { optional: true },
    ),
    query(':leave',
      animate('300ms', style({ opacity: 0 })),
      { optional: true },
    ),
  ]),
]);

export const slideIn = trigger('slideIn', [
  state('*', style({
    transform: 'translateY(0) scale(1) rotateY(0)',
    opacity: 1,
    filter: 'blur(0) saturate(100%)',
  })),
  state('void', style({
    transform: 'translateY(20px) scale(1.1) rotateY(5deg)',
    opacity: 0,
    filter: 'blur(2px) saturate(50%)',
  })),
  transition('void => *', animate('.3s ease-in-out')),
]);
export const slideOut = trigger('slideOut', [
  state('*', style({
    transform: 'translateX(0)  scale(1)',
    opacity: 1,
  })),
  state('void', style({
    transform: 'translateY(-50%) scale(.7)',
    opacity: 0,
  })),
  transition('* => void', animate('.25s ease')),
]);

interface InOutAnimationOptions {
  enterDelay?: number;
  leaveDelay?: number;
  translationPercentage?: number;
  duration?: number;
  translationDirection?: 'X' | 'Y';
  name?: string;
}

export const inOutAnimation =
  ({
     enterDelay = 0,
     leaveDelay = 0,
     translationPercentage = 15,
     duration = 0.5,
     translationDirection = 'Y',
     name = 'inOutAnimation',
   }: InOutAnimationOptions) => trigger(
    name,
    [
      transition(
        ':enter',
        [
          style({
            transform: `translate${ translationDirection }(${ translationPercentage }%)`,
            opacity: 0,
            height: 0,
          }),
          animate(`${ duration }s ${ enterDelay }s ease-out`,
            style({ transform: `translate${ translationDirection }(0)`, opacity: 1, height: '*' })),
        ],
      ),
      transition(
        ':leave',
        [
          style({ transform: `translate${ translationDirection }(0)`, opacity: 1, height: '*' }),
          animate(`${ duration }s ${ leaveDelay }s ease-in`,
            style({
              transform: `translate${ translationDirection }(${ translationPercentage }%)`,
              opacity: 0,
              height: 0,
            })),
        ],
      ),
    ],
  );

export const popInOut = trigger(
  'popInOut',
  [
    transition(
      ':enter',
      [
        style({ transform: `scale(0.95)`, opacity: 0 }),
        animate(`0.2s 0s ease-in`,
          style({ transform: `scale(1)`, opacity: 1 })),
      ],
    ),
    transition(
      ':leave',
      [
        style({ transform: 'scale(1)', opacity: 1 }),
        animate(`0.2s 0s  ease-out`,
          style({ transform: `scale(0.95)`, opacity: 0 })),
      ],
    ),
  ],
);

export const tabChange = trigger(
  'tabChange',
  [
    transition(
      ':enter',
      [
        style({ transform: `scale(0.95)`, opacity: 0 }),
        animate(`0.2s 0s ease-in`,
          style({ transform: `scale(1)`, opacity: 1 })),
      ],
    ),
  ],
);
